import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import {
  MdManageAccounts,
  MdOutlineChat,
  MdOutlineManageHistory,
  MdStore,
} from "react-icons/md";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { TiArrowSortedDown, TiMessages } from "react-icons/ti";
import { TbMoneybag } from "react-icons/tb";
import { IoSettingsOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { RxDashboard } from "react-icons/rx";
import { GrDocumentPerformance } from "react-icons/gr";
import { TbReport } from "react-icons/tb";
import { BsCardChecklist } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { CgPerformance } from "react-icons/cg";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { isdirty_success } from "../../../Pages/actions/dirty";

const Html = ({ isAllow, isOpen, user }) => {
  const dispatch = useDispatch();
  const isDirty = useSelector((state) => state.dirty.isDirty);
  const { t } = useTranslation();
  const location = useLocation();
  const history = useNavigate();
  const url = window.location.pathname;
  const unReadCount = useSelector((state) => state?.count?.data);

  const activecls = (tab) => {
    let url = window.location.href;
    let value = false;
    tab?.map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };

  const menus = [
    {
      name: `${t("dashboard")}`,
      icon: <RxDashboard className="w-[30px] h-[30px] p-[5px]" />,
      activeIcon: (
        <RxDashboard className="w-[30px] h-[30px] p-[5px] text-white" />
      ),
      url: "/dashboard",
      key: "readDashboard",
    },

    {
      name: `${t("attendanceRegistration")}`,
      icon: <BsCardChecklist className="text-[20px]" />,
      activeIcon: <BsCardChecklist className="text-[20px]" />,
      menu: [
        {
          name: `${t("clockInOutScreen")}`,
          icon: <BsCardChecklist className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <BsCardChecklist className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/checkin/checkout",
          key: "readClock",
        },
        {
          name: `${t("attendance")}`,
          icon: <BsCardChecklist className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <BsCardChecklist className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/attendance",
          key: "readattendance",
        },
      ],
    },

    {
      name: `${t("performanceManagement")}`,
      icon: <CgPerformance className="text-[20px]" />,
      activeIcon: <CgPerformance className="text-[20px]" />,
      menu: [
        {
          name: `${t("monthlyTargetMenu")}`,
          icon: <TbMoneybag className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <TbMoneybag className="w-[30px] h-[30px] p-[5px] text-white " />
          ),
          url: "/budget",
          key: "readbudget",
        },
        {
          name: `${t("dailyTarget")}`,
          icon: <TbMoneybag className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <TbMoneybag className="w-[30px] h-[30px] p-[5px] text-white " />
          ),
          url: "/daily/bug",
          key: "readdailyBudget",
        },
        {
          name: `${t("dailyReport")}`,
          icon: <TbReport className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <TbReport className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/dailyreport",
          key: "readdailyreport",
        },
        {
          name: `${t("performance")}`,
          icon: (
            <GrDocumentPerformance className="w-[30px] h-[30px] p-[5px] " />
          ),
          activeIcon: (
            <GrDocumentPerformance className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/performance",
          key: "readperformance",
        },
      ],
    },

    {
      name: `${t("shiftManagement")}`,
      icon: <MdOutlineManageHistory className="text-[20px]" />,
      activeIcon: <MdOutlineManageHistory className="text-[20px]" />,
      menu: [
        {
          name: `${
            user?.role === "staff" ? t("myShifts") : t("shiftManagement")
          }`,
          icon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] " />
          ),
          activeIcon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/Shift",
          key: "readShift",
        },
        {
          name: `${t("calendarView")}`,
          icon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] " />
          ),
          activeIcon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/calendar",
          key: "readCalendar",
        },
      ],
    },
    {
      name: `${t("masterManagement")}`,
      icon: <MdManageAccounts className="text-[20px]" />,
      activeIcon: <MdManageAccounts className="text-[20px]" />,
      menu: [
        {
          name: `${t("storeManagement")}`,
          icon: <MdStore className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <MdStore className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/store",
          key: "readStore",
        },
        {
          name: `${t("staff")}`,
          icon: <HiOutlineUserGroup className="w-[30px] h-[30px] p-[5px]" />,
          activeIcon: (
            <HiOutlineUserGroup className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/staff",
          key: "readStaff",
        },
        {
          name: `${t("businessPartners")}`,
          icon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] " />
          ),
          activeIcon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/business/partner",
          key: "readBusiness",
        },
      ],
    },

    {
      name: `${t("messages")}`,
      icon: <TiMessages className="text-[20px]" />,
      activeIcon: <TiMessages className="text-[20px]" />,
      menu: [
        {
          name: `${t("chat")}`,
          icon: <MdOutlineChat className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <MdOutlineChat className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/chats",
          key: "readchats",
        },
        {
          name: `${t("bulletinBoard")}`,
          icon: <MdOutlineChat className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <MdOutlineChat className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/bulletin/board",
          key: "readBulletin",
        },
      ],
    },

    {
      name: `${t("globalSettings")}`,
      icon: <IoSettingsOutline className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: (
        <IoSettingsOutline className="w-[30px] h-[30px] p-[5px] text-white" />
      ),
      url: "/global/setting",
      key: "readsetting",
    },
  ];

  const AllURls = ["dailyreport/add", "dailyreport/edit"];

  const shouldShowPopup = (url) => {
    if (!url) return false;
    const cleanUrl = url.startsWith("/") ? url.slice(1) : url;
    return AllURls.some((path) => cleanUrl.startsWith(path));
  };

  const handleOnboarding = (e, data) => {
    e.preventDefault();
    const showPopup = shouldShowPopup(url) && isDirty;
    if (!showPopup) {
      history(data);
      // dispatch(isdirty_success(false));
      return;
    }
    Swal.fire({
      title: t("actionRequired"),
      text: t("sideBarAction"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3730ff",
      cancelButtonColor: "#d33",
      confirmButtonText: t("sideBarLeave"),
      cancelButtonText: t("sideBarCancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(isdirty_success(false));
        history(data);
      }
    });
  };

  return (
    <>
      <div
        className={`px-[12px]   sidebar-padding ${isOpen && styles.sm_sidebar}`}
        component="siderbar"
      >
        <ul className="space-y-2 ">
          {menus.map((itm) => {
            return (
              <>
                {itm.icon ? (
                  <>
                    <li className="!mt-0">
                      {itm.menu ? (
                        <>
                          {isAllow(
                            itm.menu.map((itm) => itm.key).toString()
                          ) ? (
                            <>
                              <Disclosure
                                as="div"
                                defaultOpen={activecls(
                                  itm.menu.map((itm) => itm.url)
                                )}
                              >
                                {({ open }) => (
                                  <>
                                    <tooltip placement="right" title={itm.name}>
                                      <Disclosure.Button className="w-full p-4 rounded-md flex items-center justify-between gap-[12px] transition-all duration-300 sidebar-drop">
                                        <span className="text-sm fow-full  rounded-md flex items-center justify-between gap-[12px] transition-all duration-300 font-normal text-inherit flex items-center gap-[12px] crm ">
                                          <span className="relative">
                                            {itm?.name == "Chat" &&
                                              unReadCount > 0 && (
                                                <span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]"></span>
                                              )}
                                            {!open ? (
                                              <>{itm?.icon}</>
                                            ) : (
                                              <>{itm?.activeIcon}</>
                                            )}
                                          </span>
                                          <span className="text-inherit leading-none text-[#5B6670] sidebar_text whitespace-nowrap">
                                            {itm.name}
                                          </span>
                                        </span>
                                        <TiArrowSortedDown
                                          className={`${
                                            open ? "" : "-rotate-90 transform"
                                          } h-3 w-3 transition-all duration-500 arrow-icon`}
                                        />
                                      </Disclosure.Button>
                                    </tooltip>
                                    <Transition
                                      enter="transition duration-300 ease-in-out"
                                      enterFrom="transform scale-95 opacity-0"
                                      enterTo="transform scale-300 opacity-300"
                                      leave="transition duration-300 ease-in-out"
                                      leaveFrom="transform scale-300 opacity-300"
                                      leaveTo="transform scale-95 opacity-0"
                                    >
                                      <Disclosure.Panel>
                                        <ul className="space-y-2">
                                          {itm.menu?.map((sitm) => {
                                            return (
                                              <>
                                                {isAllow(sitm.key) ? (
                                                  <li className="nested-li px-4">
                                                    {" "}
                                                    <NavLink
                                                      className={(isActive) =>
                                                        "p-4 drop-text rounded-md block text-sm font-normal text-[#333333] cursor-pointer !no-underline transition-all " +
                                                        (location?.pathname.includes(
                                                          sitm.url
                                                        ) &&
                                                          " !text-[#3C73AA] !bg-[#4d899247]  !font-medium")
                                                      }
                                                      // to={sitm.url}
                                                      onClick={(e) => {
                                                        handleOnboarding(
                                                          e,
                                                          sitm.url
                                                        );
                                                      }}
                                                    >
                                                      <div className="flex items-center relative ">
                                                        <span className="w-[7px] h-[7px] bg-[#596b77] rounded-full block absolute -left-[4px]"></span>
                                                        <span
                                                          className="text-inherit leading-none nested-text font-[500] ps-5"
                                                          title={sitm.name}
                                                        >
                                                          {sitm.name}
                                                        </span>
                                                      </div>
                                                    </NavLink>
                                                  </li>
                                                ) : null}
                                              </>
                                            );
                                          })}
                                        </ul>
                                      </Disclosure.Panel>
                                    </Transition>
                                  </>
                                )}
                              </Disclosure>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {isAllow(itm.key) ? (
                            <>
                              <tooltip
                                placement="top"
                                color="#3730ff"
                                title={itm.name}
                              >
                                <NavLink
                                  // to={itm.url}
                                  onClick={(e) => {
                                    handleOnboarding(e, itm.url);
                                  }}
                                  className={(isActive) =>
                                    "ps-3 pe-2 py-2 rounded-xl flex items-center gap-[6px] text-sm font-[500] text-[#333333] hover:bg-[#3C73AA14] !no-underline transition-all !mx-auto !mb-2" +
                                    (location?.pathname.includes(itm.url) &&
                                      " !text-white !bg-[#3C73AA] !font-medium")
                                  }
                                >
                                  <span className="relative ">
                                    {itm?.name == "Chat" && unReadCount > 0 && (
                                      <span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]"></span>
                                    )}
                                    {!location?.pathname.includes(itm.url) ? (
                                      <>{itm.icon}</>
                                    ) : (
                                      <>{itm?.activeIcon}</>
                                    )}
                                  </span>

                                  <span
                                    className={`text-inherit leading-none ${
                                      location?.pathname.includes(itm.url)
                                        ? "text-[#fff]"
                                        : "text-[#5B6670]"
                                    }  font-[400] sidebar_text whitespace-nowrap`}
                                  >
                                    {itm.name}
                                  </span>
                                </NavLink>
                              </tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <h6
                        className={`${
                          isOpen ? "py-[12px] " : "p-[12px]  text-md"
                        } text-xs font-medium text-[#7E8B99] mt-[12px]`}
                      >
                        <span className=" sidebar_text text-center">
                          {" "}
                          {itm.name}{" "}
                        </span>
                      </h6>
                    </li>
                  </>
                )}
              </>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
